import { ReportParameters } from "./reportParameters";

export class Report{
    
id:string;
reportName:string;
reportCriteria:ReportParameters[];

}


// WEBPACK FOOTER //
// ./src/app/modules/reports/custom-reports/entities/report.ts